import { CONTACT_SHORT_CODES, MISC_SHORT_CODES } from 'constants/short-codes';
import useRequest from 'hooks/useRequest';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { getCustomColumns, getVariables } from 'services/account.service';

const VARIABLES = {
  ...CONTACT_SHORT_CODES,
  ...MISC_SHORT_CODES,
};

const defaultVariableOptions = Object.keys(VARIABLES).map((key) => ({
  value: key,
  label: VARIABLES[key],
}));

const useVariables = ({ messageVariables = true } = {}) => {
  const account = useSelector((state) => state.settings.account);
  const [data, { loading }] = useRequest(getCustomColumns, account.hash);
  const [variables, { loading: loadingVariables }] = useRequest(
    getVariables,
    {
      account_id: account.id,
    },
    {
      skip: !messageVariables,
    },
  );
  const options = useMemo(() => {
    const defaultGroup = {
      label: 'Default',
      options: defaultVariableOptions,
    };
    const options = [defaultGroup];

    if (data) {
      options.push({
        label: 'Custom Fields',
        options: data.map((i) => ({
          label: i.column_name,
          value: `{CUSTOM_${i.column_variable_name}}`,
        })),
      });
    }

    if (variables) {
      options.push({
        label: 'Message Variables',
        options: variables.map((i) => ({
          label: i.variable,
          value: i.variable,
        })),
      });
    }
    return options;
  }, [data, variables]);

  const variablesMap = useMemo(() => {
    const customVariables = (data || []).reduce((acc, i) => {
      acc[`{CUSTOM_${i.column_variable_name}}`] = i.column_name;
      return acc;
    }, {});

    const messageVariables = (variables || []).reduce((acc, i) => {
      acc[i.variable] = i.variable;
      return acc;
    }, {});

    return {
      ...VARIABLES,
      ...customVariables,
      ...messageVariables,
    };
  }, [data, variables]);

  return {
    loading: loading || loadingVariables,
    options,
    variablesMap,
  };
};

export default useVariables;
